import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ArquivosComponent } from './arquivos/arquivos.component';
import { DaoService } from './servicos/dao.service';
import { HttpModule } from '@angular/http';
import { CadastroComponent } from './cadastro/cadastro.component';
import {TooltipModule} from 'primeng/tooltip';
import {InputTextModule} from 'primeng/inputtext';
import {EditorModule} from 'primeng/editor';
import { MessageService } from 'primeng/api';
import { ImageUploadModule } from "angular2-image-upload";
import {DropdownModule} from 'primeng/dropdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {ButtonModule} from 'primeng/button';
import {ToastModule} from 'primeng/toast';
import { ListaArquivosComponent } from './lista-arquivos/lista-arquivos.component';
import {TableModule} from 'primeng/table';
import { DataMomentoPipe } from './pipes/data-momento.pipe';
import { FaleconoscoComponent } from './faleconosco/faleconosco.component';
import { NgxUiLoaderModule, NgxUiLoaderConfig } from  'ngx-ui-loader';
import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { LicitacaoComponent } from './licitacao/licitacao.component';
import { FieldsetModule } from 'primeng/fieldset';
import {TabViewModule} from 'primeng/tabview';
import {AccordionModule} from 'primeng/accordion';
import { InputMaskModule } from 'primeng/inputmask';
import { LicitacaoViewComponent } from './licitacao-view/licitacao-view.component';
import { ProgestaoComponent } from './progestao/progestao.component';
import { CadastroServidorComponent } from './cadastro-servidor/cadastro-servidor.component';
import { PipeFotoPipe } from './pipes/pipe-foto.pipe';
import {DialogModule} from 'primeng/dialog';
import {CheckboxModule} from 'primeng/checkbox';
import {ColorPickerModule} from 'primeng/colorpicker';
import { ViewPessoaComponent } from './view-pessoa/view-pessoa.component';
import { NomeCurtoPipe } from './pipes/nome-curto.pipe';
import { HtmlRemovedorPipe } from './pipes/html-removedor.pipe';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import { CadastroPersonalizadoComponent } from './cadastro-personalizado/cadastro-personalizado.component';
import { ArquivospComponent } from './arquivosp/arquivosp.component';
import { MeuLinkComponent } from './meu-link/meu-link.component';
import { RelInvestimentosComponent } from './rel-investimentos/rel-investimentos.component';
import { ConselhoAdministrativoComponent } from './conselho-administrativo/conselho-administrativo.component';
import { ConselhoFiscalComponent } from './conselho-fiscal/conselho-fiscal.component';
import { JuntaRecursosComponent } from './junta-recursos/junta-recursos.component';
import { ComiteInvestimentosComponent } from './comite-investimentos/comite-investimentos.component';
import { CertidaoDebitoComponent } from './certidao-debito/certidao-debito.component';
import { CredenciadosComponent } from './credenciados/credenciados.component';
import { TelaContabeisComponent } from './tela-contabeis/tela-contabeis.component';
import { AutenticadorComponent } from './autenticador/autenticador.component';
import { InscritorComponent } from './inscricoes/inscritor/inscritor.component';
import { CensoDigitalComponent } from './relatorios/censo-digital/censo-digital.component';
import { ConsultaCensoComponent } from './consulta-censo/consulta-censo.component';
import {PasswordModule} from 'primeng/password';
import { ArquivoInfoComponent } from './arquivo-info/arquivo-info.component';
import { ROuvidoriaComponent } from './r-ouvidoria/r-ouvidoria.component';
import { MesPipe } from './mes.pipe';
import {KeyFilterModule} from 'primeng/keyfilter';
import { DiretoriaExecutivaComponent } from './diretoria-executiva/diretoria-executiva.component';
import { AgendaComponent } from './agenda/agenda.component';
import { BotaoComponent } from './botao/botao.component';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import { GovernancaCorporativaComponent } from './governanca-corporativa/governanca-corporativa.component';
import { RelatorioControleInternoComponent } from './relatorio-controle-interno/relatorio-controle-interno.component';
import { OrganizacaoComponent } from './organizacao/organizacao.component';




declare var require: any;

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  "bgsColor": "orange",
  "fgsType": "square-jelly-box",
  "logoUrl": "https://www.diviprev.mg.gov.br/wp-content/uploads/2019/12/LogoDiviprevFundoTransparente.png",
  "fgsColor": "#ebab34",
  "text": "Processando",
  
}



@NgModule({
  declarations: [
    AppComponent,
    ArquivosComponent,
    CadastroComponent,
    DataMomentoPipe,
    ListaArquivosComponent,
    FaleconoscoComponent,
    PesquisaComponent,
    LicitacaoComponent,
    LicitacaoViewComponent,
    ProgestaoComponent,
    CadastroServidorComponent,
    PipeFotoPipe,
    ViewPessoaComponent,
    NomeCurtoPipe,
    HtmlRemovedorPipe,
    CadastroPersonalizadoComponent,
    ArquivospComponent,
    MeuLinkComponent,
    RelInvestimentosComponent,
    ConselhoAdministrativoComponent,
    ConselhoFiscalComponent,
    JuntaRecursosComponent,
    ComiteInvestimentosComponent,
    CertidaoDebitoComponent,
    CredenciadosComponent,
    TelaContabeisComponent,
    AutenticadorComponent,
    InscritorComponent,
    CensoDigitalComponent,
    ConsultaCensoComponent,
    ArquivoInfoComponent,
    ROuvidoriaComponent,
    MesPipe,
    DiretoriaExecutivaComponent,
    AgendaComponent,
    BotaoComponent,
    GovernancaCorporativaComponent,
    RelatorioControleInternoComponent,
    OrganizacaoComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    DialogModule,
    InputTextModule,
    CheckboxModule,
    PasswordModule,
    InputMaskModule,
    ColorPickerModule,
    ConfirmDialogModule,
    KeyFilterModule,
    OverlayPanelModule,
    TooltipModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    EditorModule,
    ReactiveFormsModule,
    AccordionModule,
    TabViewModule,
    FieldsetModule,
    ToastModule,
    DropdownModule,
    TableModule,
    ButtonModule,
    ImageUploadModule,
    FormsModule,
    AppRoutingModule
  ],
  providers: [DaoService,MessageService,ConfirmationService],
  bootstrap: [AppComponent]
})
export class AppModule { }
